import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { privacy: () => import('./PrivacyPage.vue') },
} satisfies FeatureRoutes
